import TableRowText, { ITableRowTextProps } from '../text/TableRowText';

const TableRowCurrency = (props: ITableRowTextProps) => {
  return <TableRowText {...props} className='currency' />;
};

export default TableRowCurrency;
